/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { checkToken } from 'api/utils';
import { getNominasPlazasPercepciones } from 'api/nominas/calculosDeNominaEncabezado';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

const TablaPercepciones = ({ nominaPlaza }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [percepciones, setPercepciones] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (nominaPlaza) {
      const fetchAll = async () => {
        setLoading(true);
        await checkToken();
        const [
          _percepciones,
          _data,
        ] = await Promise.all([
          getPercepciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getNominasPlazasPercepciones({ nomina_plaza: nominaPlaza }),
        ]);
        const filteredData = _data.filter((e) => e.importe > 0);
        if (mounted) {
          setPercepciones(_percepciones);
          setData(formatReceived(filteredData));
          setLoading(false);
        }
      };
      fetchAll();
    } else {
      setData([]);
    }
    return () => { mounted = false; };
  }, [nominaPlaza]);

  const columns = [
    {
      titleText: 'Percepciones',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 250,
      render: (val) => {
        const _percepcion = percepciones.find((e) => e.id === val);
        return `${_percepcion?.clave} - ${_percepcion?.descripcion}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default TablaPercepciones;
